// B2B Login Page - AIAgentify Voyager
import { useState } from 'react';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import { useB2B } from '../context/B2BContext';

export default function B2BLogin() {
  const navigate = useNavigate();
  const { login, isAuthenticated, loading } = useB2B();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!loading && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="b2b-login-page">
      <div className="b2b-login-container">
        <div className="b2b-login-left">
          {/* Voyager Logo 
          <div style={{ marginBottom: '24px' }}>
            <img 
              src="/voyager-logo-transparent.svg" 
              alt="AIAgentify Voyager" 
              style={{ height: '120px' }}
            />
          </div>*/}
          
          <h1>AIAgentify Voyager</h1>
          <p>Turn website visitors into booked clients with AI-powered travel assistance.</p>
          
          <div className="b2b-login-features">
            <div className="b2b-login-feature">
              <span className="icon">🤖</span>
              24/7 AI chat on your website
            </div>
            <div className="b2b-login-feature">
              <span className="icon">📧</span>
              Automatic lead capture
            </div>
            <div className="b2b-login-feature">
              <span className="icon">✈️</span>
              Flight & hotel search built-in
            </div>
            <div className="b2b-login-feature">
              <span className="icon">🎨</span>
              White-label with your branding
            </div>
          </div>
        </div>
        
        <div className="b2b-login-right">
          <div className="b2b-login-header">
            {/* <div className="b2b-login-logo">AIAgentify Voyager</div> */}
             <div style={{ marginBottom: '24px', textAlign: 'center' }}>
            <img 
              src="/voyager-logo-transparent.svg" 
              alt="AIAgentify Voyager" 
              style={{ height: '120px' }}
            />
          </div>
            <div className="b2b-login-subtitle">Agent Portal</div>
          </div>
          
          <form className="b2b-login-form" onSubmit={handleSubmit}>
            {error && <div className="b2b-login-error">{error}</div>}
            
            <div className="b2b-form-group">
              <label className="b2b-form-label">Email</label>
              <input
                type="email"
                className="b2b-form-input"
                placeholder="you@agency.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            
            <div className="b2b-form-group">
              <label className="b2b-form-label">Password</label>
              <input
                type="password"
                className="b2b-form-input"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            
            <button type="submit" className="b2b-login-btn" disabled={submitting}>
              {submitting ? 'Signing in...' : 'Sign In'}
            </button>
            
            <div className="b2b-login-divider">or</div>
            
            <div className="b2b-login-footer">
              Don't have an account? <Link to="/signup">Start free trial</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
